module.exports = __webpack_public_path__ + "img/intro_bottom_separate.578eafc6.svg";